export default __webpack_public_path__ + "static/media/gerald.1f758864.png";